import { synchronizeLullabies as synchronize } from "src/modules/lullaby/duck/epics";
import lullabyFiles from "src/modules/lullaby/lullaby-files";

export default {
  synchronize,
  clearData: lullabyFiles.deleteAll.bind(lullabyFiles)
};
